import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { OccEndpointsService } from '@spartacus/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class KbMyTicketService {

    customerId: any;
    code: string = '';
    ticketCode: string = '';
    isFromCreatenewTicketPage: boolean = false;
    isFromCreatenewTicketPageKey: string = '';

    isFromUpdateTicketPage: boolean = false;
    isFromUpdateTicketPageKey: string = '';
    constructor(private http: HttpClient,
        private occService: OccEndpointsService,) { }
    getApi() {
        return this.http.get(this.occService.buildUrl(`mytickets/supporttickets`));
    }
    postApi(payload, currentPage, sort) {
        return this.http.post(this.occService.buildUrl(`mytickets/supporttickets?page=${currentPage}&sort=${sort}&pageSize=5`), payload);
    }
    createNewGetApi() {
        return this.http.get(this.occService.buildUrl(`mytickets/addsupporttickets`));
    }
    onCustomerIdSelect(customerId, categoryId) {
        return this.http.get(this.occService.buildUrl(`mytickets/associatedObjects?customerId=${customerId}&categoryId=${categoryId}`));
    }
    createNewTicketPostApi(load2: any, Payload?: FormData) {
        const headers = new HttpHeaders();
        // associatedTo=NA&defaultSoldTo=0001032856_0313_20_00&fields=DEFAULT&message=hellorequeastParam&subject=hellorequeast&ticketCategoryCode=Core
        headers.set('Content-Type', 'multipart/form-data');
        return this.http.post(this.occService.
            buildUrl(`mytickets/createSupportTicket?associatedTo=${load2.associatedTo}&defaultSoldTo=${load2.customerId}&fields=DEFAULT&message=${load2.message}&subject=${load2.subject}&ticketCategoryCode=${load2.categoryId}`)
            , Payload, { headers: headers });
    }
    ticketUpdateGetApi(code, tickCode) {
        this.code = code;
        this.ticketCode = tickCode;
        return this.http.get(this.occService.buildUrl(`mytickets/update-support-ticket/${code}/${tickCode}`));
    }
    editFileUploadApi(payload: any, file?: FormData) {
        return this.http.post(this.occService.buildUrl(`mytickets/update-support-ticket/${this.code}/${this.ticketCode}?message=${payload?.message}&status=${payload?.status}`), file);
    }

}


